import * as React from "react";
import Chip from "@mui/material/Chip";
const Chips = ({color="primary",title}) => {
  return (
        <Chip label={title} style={{}} color={color} variant="outlined" onClick={()=>{console.log("You clicked")}}/>  );
};

export default Chips;
